import styled from 'styled-components'

const BedroomList = styled.div`
  padding-top: ${props => props.theme.gutter}px;

  display: flex;
  flex-direction: row;

  align-items: flex-end;
`

export default BedroomList
